import { render, staticRenderFns } from "./agreeAccept.vue?vue&type=template&id=08c510db&scoped=true"
import script from "./agreeAccept.vue?vue&type=script&lang=js"
export * from "./agreeAccept.vue?vue&type=script&lang=js"
import style0 from "./agreeAccept.vue?vue&type=style&index=0&id=08c510db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c510db",
  null
  
)

export default component.exports